// extracted by mini-css-extract-plugin
export default {"Btn_loginForm":"style_Btn_loginForm__BO9Cq"};